module.exports = __webpack_public_path__ + "img/btp.e54c17d9.jpg";